module.exports = __webpack_public_path__ + "static/img/06.531922b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/huegler/06.jpg
// module id = 380
// module chunks = 1